import React from 'react';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {Atom} from '@packages/systems/wfdl';
import {getChildren} from '@packages/utilities/data-utils';

const FlexColumn = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Column',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
  },
  render: FlexColumn,
  fields: {children: TListOfElement},
});

export default config;
